import React, { useState, useEffect } from 'react';
import { makeStyles, Box, Typography } from '@material-ui/core';
import { useTranslate } from 'react-admin';
import GreenSwitch from '../CustomizedUIs/GreenSwitch';
import CustomPoper from '../CustomizedUIs/CustomPoperCalendar';
import OneLineTextField from '../CustomizedUIs/CustomTextFiled';
import CustomTextField from '../CustomizedUIs/CustomTextFieldWithFontSize';
import { useSelector, useDispatch } from 'react-redux';
import { changeNodeGlobalData } from '../redux/actions/tree-action';
import SelectBoxFilter from '../common/select-box-filter';
import { useDataProvider } from 'react-admin';

const useStyles = makeStyles(theme => ({
    btn: {
        fontFamily: 'UniviaPro-Bold',
        fontStyle: 'normal',
        fontStretch: 'normal',
        fontWeight: 'normal',
        lineHeight: '11px',
        letterSpacing: '0.36px',
        color: '#237fc2',
        fontSize: '9px',
        paddingRight: '5px'
    },

    Title: {
        fontFamily: 'UniviaPro-Medium',
        fontStyle: 'normal',
        fontStretch: 'normal',
        fontWeight: 500,
        lineHeight: '21.6px',
        letterSpacing: 'normal',
        color: '#4f5064',
        fontSize: '18px',
    },
    borderCard: {
        borderRadius: '4px',
        backgroundColor: 'rgba(255,255,255,0.5)',
        // opacity: 0.5,
        border: "solid 1px #c1e5fa",
        width: '500px',
        // height: '132px',
        marginTop: '18px'
    },
    titleNodeType: {
        fontFamily: 'UniviaPro-Medium',
        fontStyle: 'normal',
        fontStretch: 'normal',
        fontWeight: 500,
        lineHeight: '13.2px',
        letterSpacing: 'normal',
        color: '#4f5064',
        fontSize: '11px',
    },
    TexTSelect: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '24px',
        letterSpacing: '0.13px',
        color: '#4f5064',
    },
    boxBoder: {
        borderBottom: '1px solid',
        borderRight: '1px solid',
        borderBottomColor: '#f3f7fa',
        borderRightColor: '#f3f7fa',
    },
    switch: {
        width: 170,
        height: 30,
        backgroundColor: theme.palette.common.white,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around',
        // marginLeft: '24px'
    },
    switchText: {
        whiteSpace: 'nowrap',
        fontFamily: "UniviaPro-Bold",
        fontSize: "9px",
        fontWeight: "bold",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: '11px',
        letterSpacing: " 0.36px",
        color: "#4f5064",
    },
    inputMulti: {
        width: '500px',
        borderRadius: '2px',
        // '&$input': {
        //     width: 385
        // },
    },
    inputPopper: {
        alignSelf: 'flex-end',
        position: 'absolute',
        right: '16px',
        top: '20px'
    },
    borderBrowse: {
        borderRadius: '4px',
        backgroundColor: 'rgba(255,255,255,0.5)',
        // opacity: 0.5,
        border: "solid 1px #c1e5fa",
        width: '500px',
        // height: '132px',
        marginTop: '18px'
    },
    btnAdd: {
        padding: 5,
        minWidth: 'unset',
        width: 25,
        height: 25,
        backgroundColor: '#ffffff',
        borderRadius: 10,
        border: 'solid 2px #e5f1f8;',
    },
    btn: {
        fontFamily: 'UniviaPro-Bold',
        fontStyle: 'normal',
        fontStretch: 'normal',
        fontWeight: 'normal',
        lineHeight: '11px',
        letterSpacing: '0.36px',
        color: '#ffffff',
        fontSize: '9px',
        textAlign: 'center'
    },

    btnIcon: {
        width: 14,
        height: 14
    },

}));

function LaunchTVApp() {
    const classes = useStyles();
    const translate = useTranslate();
    const dispatch = useDispatch();
    const dataProvider = useDataProvider();

    const [openPoper, setOpenPopper] = useState(false);
    const [listTVApps, setListTVApps] = useState([]);

    const { isEditing, nodeSelected } = useSelector(state => state.tree);
    const { nodeApplication } = nodeSelected.applicationData;
    const { tvApp } = nodeApplication;
    const { message, hasInfoMessage, app, data } = tvApp;

    const onChangeData = (data) => {
        const newNode = {
            ...nodeSelected.applicationData,
            nodeApplication: {
                ...nodeApplication,
                tvApp: {
                    ...tvApp,
                    ...data
                }
            }
        };
        dispatch(changeNodeGlobalData(newNode));
    }

    const onChangeMessage = (event) => {
        onChangeData({
            message: {
                text: event.target.value,
                fontSize: message.fontSize
            }
        });
    }

    const onChangeFontSize = (fontSize) => {
        onChangeData({
            message: {
                text: message.text,
                fontSize
            }
        });
    }

    const getListTVApps = () => {
        dataProvider('GET_LIST', 'tvapplication', {
            filter: {},
            pagination: {},
            sort: { field: 'name', order: 'ASC' },
        }).then(({ data }) => {
            setListTVApps(data);
            if (!app && data.length > 0) {
                onChangeData({ app: data[0] });
            }
        }).catch(error => console.error('getListTVApps error', error));
    }

    useEffect(() => {
        getListTVApps();
    }, []);

    return (
        <Box >
            <Box mt={3.5}>
                <Box style={{ width: 500 }}>
                    <SelectBoxFilter
                        disabled={!isEditing}
                        data={listTVApps}
                        label={translate('resources.infoPage.launchTVApp.availableApp')}
                        value={app ? app.name : ''}
                        onChange={(value) => onChangeData({ app: value })}
                        keyName='name'
                        placeholder={translate('resources.infoPage.filter_availableApp')}
                    />
                </Box>
                <Box style={{ marginTop: 20 }} >
                    <OneLineTextField
                        disabled={!isEditing}
                        id="filled-basic"
                        label={'Data'}
                        value={data}
                        onChange={event => onChangeData({ data: event.target.value })}
                        style={{ width: 500 }}
                        endDom={<CustomPoper
                            color={'#e5f1f8'}
                            fontSize={'11px'}
                            open={openPoper}
                            handleClick={() => setOpenPopper(true)}
                            handleClose={() => setOpenPopper(false)}
                            title={translate(`resources.infoPage.launch_tv_app_data`)}
                            content={translate(`resources.infoPage.launch_tv_app_content`)}
                            icon={<b>?</b>}
                        />}
                    />
                </Box>
                <Box px={1} className={classes.switch} style={{ marginTop: 15, position: 'relative' }}>
                    <Typography className={classes.switchText} style={{ marginRight: 35 }}>
                        {translate('pos.common.infoMessage')}
                    </Typography>
                    <GreenSwitch
                        checked={hasInfoMessage}
                        disabled={!isEditing}
                        size='small'
                        style={{ color: 'white' }}
                        onChange={(event) => onChangeData({ hasInfoMessage: event.target.checked })}
                    />
                </Box>
                {
                    hasInfoMessage && (
                        <Box style={{ marginTop: 20 }} >
                            <CustomTextField
                                disabled={!isEditing}
                                className={classes.inputMulti}
                                id="textfield-message"
                                multiline
                                rows={4}
                                value={message.text}
                                onChange={onChangeMessage}
                                placeholder={translate(`pos.messages.placeholder`)}
                                fontSize={message.fontSize}
                                setFontSize={onChangeFontSize}
                                infoPage
                                endDom={
                                    <Box>
                                        <Box className={classes.inputPopper}>
                                            <CustomPoper
                                                color={'#e5f1f8'}
                                                fontSize={'11px'}
                                                open={openPoper}
                                                handleClick={() => setOpenPopper(true)}
                                                handleClose={() => setOpenPopper(false)}
                                                title={translate(`pos.messages.constent`)}
                                                content={translate(`pos.messages.constentContent`)}
                                                icon={<b>?</b>}
                                            />
                                        </Box>
                                    </Box>
                                }
                            />
                        </Box>
                    )
                }
            </Box>
        </Box>

    )
}

export default LaunchTVApp;
